import { Account, Project } from "../../SharedModule/types/shared-module-types";
import HttpService from "../../SharedModule/utils/api";
const BASE_URL = "/products/External";

function getClients(): Promise<Account[]> {
  return HttpService.req(`${BASE_URL}/Clients`);
}

function getProjects(): Promise<Project[]> {
  return HttpService.req(`${BASE_URL}/Projects`);
}
export const ExternalService = {
  getClients,
  getProjects,
};
